import React from 'react'
import moment from 'moment-timezone'
import { notificationEnabled } from './announcementContent'

export default function AnnouncementNotificationStatus({ announcement, timezone }) {
  const summary = announcement.notificationSummary
  if (!summary) return <span className="text-muted">Notify players on creation: {notificationEnabled(announcement.notifications) ? 'Yes' : 'No'}. Delivery is not confirmed.</span>

  let message
  switch (summary.status) {
    case 'queued':
      message = summary.recipientCount === 0
        ? 'No eligible players to notify.'
        : `Notifications queued for ${summary.recipientCount} players. Delivery is not confirmed.`
      break
    // Notifications wait while the announcement is translated, then go in each player's language (ADR 0013).
    case 'waiting':
      message = `Notifications for ${summary.recipientCount} players wait for the announcement's translation. They are sent once it is ready, each in the player's language. Delivery is not confirmed.`
      break
    case 'dispatching':
    case 'pending':
      message = 'Notification request is processing. Delivery is not confirmed.'
      break
    case 'rejected':
      message = 'Latest notification request was rejected. No notifications were queued by this request.'
      break
    case 'unavailable':
      message = 'Notification status is unavailable. Reload to check again.'
      break
    default:
      message = 'Notification outcome is unconfirmed. Some notifications may have been queued.'
  }
  const date = summary.createdAt ? moment(summary.createdAt) : null
  return <span className="text-muted">{message}{date?.isValid() && <> Latest request: {date.tz(timezone).format('DD MMM YYYY, HH:mm')} · {timezone}.</>}</span>
}
